/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1714089600000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Fri Apr 26 2024 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "eloqua",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Eloqua",
          "depth": 0,
          "id": "connect-to-eloqua"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Contacts",
          "depth": 1,
          "id": "contacts"
        }, {
          "value": "Accounts",
          "depth": 1,
          "id": "accounts"
        }, {
          "value": "Custom objects",
          "depth": 1,
          "id": "custom-objects"
        }, {
          "value": "Contact lists",
          "depth": 1,
          "id": "contact-lists"
        }, {
          "value": "Email trigger",
          "depth": 1,
          "id": "email-trigger"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      img: "img",
      h3: "h3",
      h4: "h4"
    }, _provideComponents(), props.components), {PremiumDestination, NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!PremiumDestination) _missingMdxReference("PremiumDestination", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(PremiumDestination, {
        destinationName: "Oracle Eloqua"
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Contacts"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to ", _jsx(_components.a, {
                href: "https://docs.oracle.com/en/cloud/saas/marketing/eloqua-user/Help/Contacts/Contacts.htm",
                children: "Eloqua contacts"
              })]
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Accounts"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to ", _jsx(_components.a, {
                href: "https://docs.oracle.com/en/cloud/saas/marketing/eloqua-user/Help/Accounts/Accounts.htm",
                children: "Eloqua accounts"
              })]
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Custom Objects"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to any ", _jsx(_components.a, {
                href: "https://docs.oracle.com/en/cloud/saas/marketing/eloqua-user/Help/CustomObjects/CustomObjects.htm",
                children: "Eloqua custom object"
              })]
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Contact Lists"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to ", _jsx(_components.a, {
                href: "https://docs.oracle.com/en/cloud/saas/marketing/eloqua-user/Help/SharedLists/SharedContactLists.htm",
                children: "Eloqua contact lists"
              })]
            }), _jsx(_components.td, {
              children: "Add"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Email Trigger"
              })
            }), _jsxs(_components.td, {
              children: ["Sync data from any source to ", _jsx(_components.a, {
                href: "https://docs.oracle.com/en/cloud/saas/marketing/eloqua-develop/Developers/RESTAPI/2.0/email-deployment/email-deployment-API.htm",
                children: "trigger"
              }), " emails in Eloqua"]
            }), _jsx(_components.td, {
              children: "--"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-eloqua",
        children: "Connect to Eloqua"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Eloqua"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Then ", _jsx(_components.strong, {
          children: "Authorize connection"
        }), " by clicking ", _jsx(_components.strong, {
          children: "Log in to Eloqua"
        }), ". Clicking the button leads you through your Eloqua login and asks for Hightouch to have authorization to your Eloqua instance."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destinations-eloqua-auth.png",
          alt: "Authorizing Eloqua in Hightouch"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've finished, Hightouch displays an ", _jsx(_components.strong, {
          children: "Authorization successful"
        }), " message."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destinations-eloqua-auth-successful.png",
          alt: "Authorization successful in Hightouch"
        })
      }), "\n", _jsx(_components.p, {
        children: "To finish connecting, give your Eloqua destination a descriptive name."
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've connected your Eloqua destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Eloqua destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "contacts",
        children: "Contacts"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports creating new contacts and updating existing ones."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can match rows in your model with contacts in Eloqua on any contact field. We recommend matching on a unique field, such as ", _jsx(_components.strong, {
          children: "Email address"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync any columns from your source to Eloqua contact fields."
      }), "\n", _jsx(_components.h3, {
        id: "accounts",
        children: "Accounts"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports creating new accounts and updating existing ones."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can match rows in your model with accounts in Eloqua on any account field. We recommend matching on a unique field, such as ", _jsx(_components.strong, {
          children: "Eloqua Company ID"
        }), " or a unique custom field."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync any columns from your source to Eloqua account fields."
      }), "\n", _jsx(_components.h3, {
        id: "custom-objects",
        children: "Custom objects"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports creating new instances of custom objects and updating existing ones."
      }), "\n", _jsx(Info, {
        children: _jsx(_components.p, {
          children: "Custom objects and their fields must already be defined on your Eloqua UI\nbefore Hightouch can sync to them."
        })
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-2",
        children: "Record matching"
      }), "\n", _jsx(_components.p, {
        children: "You can match rows in your model with custom objects in Eloqua on any custom object field."
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-2",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync any columns from your source to Eloqua any existing field in your custom object."
      }), "\n", _jsx(_components.h3, {
        id: "contact-lists",
        children: "Contact lists"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports syncing data to Eloqua contact lists."
      }), "\n", _jsx(_components.p, {
        children: "You can create a new contact list or use an existing one. When creating a new list, you can optionally enter a name; otherwise, Hightouch defaults to the name of the associated model."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-3",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can match rows in your model with contacts in Eloqua on any contact field. We recommend matching on a unique field, such as ", _jsx(_components.strong, {
          children: "Email address"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-3",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync any columns from your source to Eloqua contact fields."
      }), "\n", _jsx(_components.h3, {
        id: "email-trigger",
        children: "Email trigger"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports triggering emails to contacts in Eloqua."
      }), "\n", _jsx(_components.h4, {
        id: "email",
        children: "Email"
      }), "\n", _jsx(_components.p, {
        children: "For a given trigger sync, you need to select an email asset to sync to. The options come from the email assets in your Eloqua environment."
      }), "\n", _jsx(_components.p, {
        children: "Optionally, you can also enter a specific user ID to specify the sender of each email. By default, the email will be sent by the user\nthe destination is connected to."
      }), "\n", _jsx(_components.h4, {
        id: "contact-matching",
        children: "Contact matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can match rows in your model with contacts in Eloqua on by email or Eloqua's contact ID. We recommend matching on the ", _jsx(_components.strong, {
          children: "contact ID"
        }), " because matching on email\nwill require a lookup for each record since Eloqua only allows triggering emails by contact IDs. Performing the lookups will impact the performance of your sync."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
